<template>
  <m-container layout="grow">
    <m-title-bar v-if="titleStr && !$slots.header">
      <div class="flex items-center">
        <m-heading v-if="titleStr" :theme="titleTheme" class="self-center pr-3">{{ titleStr }}</m-heading>
        <slot name="header-actions" />
      </div>
    </m-title-bar>
    <slot name="header" />
    <m-dot-loader v-if="loading" :layout="['grow', 'center']" />
    <slot v-if="!loading || show" />
  </m-container>
</template>
<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue';
  import type { MHeading_ThemeProp } from '../MHeading';
  import MDotLoader from '../MDotLoader/MDotLoader.vue';
  import type { TitleOptions } from '.';
  import { isTitleOption } from '.';

  export interface Props {
    /**
     * Whether or not to show the loading indicator
     * Hides Content untile loading is complete
     */
    loading?: boolean;
    /**
     * Override loading, show content regardless of loading state
     * @description Useful for showing content while loading
     * @example <m-page-content :loading="true" show> <div v-show
     * @default false
     */
    show?: boolean;
    title?: TitleOptions | string | null | object; //https://github.com/vuejs/core/issues/4294
  }
  const props = withDefaults(defineProps<Props>(), { loading: false, title: undefined, show: false });
  const titleTheme = ref<MHeading_ThemeProp>('h1');
  const titleStr = computed(() => (isTitleOption(props.title) ? props.title.title : props.title));
  onMounted(() => {
    if (isTitleOption(props.title)) {
      titleTheme.value = props.title?.theme || 'h1';
    }
  });
</script>
